import { tutorialConstants } from '../utils/constants';
import { getIsExpired, storeItemInStorage } from '../utils/utilities';

interface StoredTutorialItem {
	value: number;
	timestamp: number;
}

class TutorialService {
	tutorialToken: string = 'tutorial_index';

	getLastTutorial = (): number => {
		const defaultTutorial = tutorialConstants.INTRODUCTION;

		const cache = localStorage.getItem(this.tutorialToken);
		if (!cache) return defaultTutorial;

		const tutorial: StoredTutorialItem = JSON.parse(cache);
		if (tutorial.value === tutorialConstants.MAYBE_LATER) {
			const isExpired = getIsExpired(tutorial.timestamp, 'minute', 15);
			return isExpired ? defaultTutorial : tutorial.value;
		}

		return tutorial.value;
	};

	storeLastTutorial = (tutorialId: number): void => {
		const lastTutorial: number = this.getLastTutorial();
		if (lastTutorial !== tutorialId) {
			const item = { value: tutorialId, timestamp: Date.now() };
			storeItemInStorage(this.tutorialToken, item);
		}
	};
}

const tutorialService = new TutorialService();
export default tutorialService;
